import { createSlice } from "@reduxjs/toolkit";
import { updateTaskOrder } from "../api/index";

const sortTasks = (tasks, order) => {
  const sortedTasks = [];
  order.map((el, i) => {
    sortedTasks.push(tasks.filter((t) => t.pos === el)[0]);
  });
  return sortedTasks;
};

// Warn if overriding existing method
if (Array.prototype.equals)
  console.warn(
    "Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."
  );
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
  // if the other array is a falsy value, return
  if (!array) return false;

  // compare lengths - can save a lot of time
  if (this.length != array.length) return false;

  for (var i = 0, l = this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arrays
      if (!this[i].equals(array[i])) return false;
    } else if (this[i] != array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
};
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", { enumerable: false });

let prevOrder = [];

export const taskSlice = createSlice({
  name: "task",
  initialState: {
    tasks: JSON.parse(localStorage.getItem("tasks")) || [],
  },
  reducers: {
    loadData: (state, action) => {
      console.log("Loaded");
      if (action.payload.length > 0) {
        const taskOrder = JSON.parse(localStorage.getItem("taskOrder")) || [];
        prevOrder = taskOrder;
        if (taskOrder.length > 0) {
          const sortedTasks = sortTasks(action.payload, taskOrder);
          state.tasks = [...sortedTasks];
          localStorage.setItem("tasks", JSON.stringify(sortedTasks));
        } else {
          state.tasks = [...action.payload];
          localStorage.setItem("tasks", JSON.stringify(action.payload));
        }
      } else {
        localStorage.removeItem("tasks");
      }
    },
    updateList: (state, action) => {
      console.log("updateList");
      state.tasks = [...action.payload];
      const taskOrder = action.payload.map((el) => {
        return el.pos;
      });
      const id = JSON.parse(localStorage.getItem("userData")).id;
      updateTaskOrder(id, { taskOrder }).catch((err) => console.log(err));
      localStorage.setItem("taskOrder", JSON.stringify([...taskOrder]));
      localStorage.setItem("tasks", JSON.stringify(action.payload));
    },
    addTask: (state, action) => {
      console.log("Added");
      const taskOrder = JSON.parse(localStorage.getItem("taskOrder"));
      taskOrder.unshift(action.payload.pos);
      state.tasks = [action.payload, ...state.tasks];
      localStorage.setItem("taskOrder", JSON.stringify([...taskOrder]));
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
    clearAllTasks: (state) => {
      state.tasks = [];
      localStorage.removeItem("tasks");
    },
    removeTask: (state, action) => {
      console.log("Removing Task");
      const pos = state.tasks.filter((t) => t.id === action.payload)[0].pos;
      // console.log(pos);
      const taskOrder = JSON.parse(localStorage.getItem("taskOrder"));
      // Decreasing the pos value by one
      // console.log("order before", taskOrder);
      const newTasks = state.tasks.map((task) => {
        if (task.pos > pos) {
          task.pos -= 1;
        }
        return task;
      });
      console.log("task length", state.tasks.length);
      //removing the heighest pos in taskOrder
      taskOrder.splice(taskOrder.indexOf(state.tasks.length - 1), 1);
      // console.log("taskOrder after", taskOrder);
      updateTaskOrder(newTasks[0].userId, { taskOrder }).catch((err) =>
        console.log(err)
      );
      prevOrder = taskOrder;
      state.tasks = [...newTasks.filter((task) => task.id !== action.payload)];
      localStorage.setItem("taskOrder", JSON.stringify([...taskOrder]));
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
    editTask: (state, action) => {
      console.log("Edited");
      let index = 0;
      const remainingTask = state.tasks.filter((task, i) => {
        if (task.id === action.payload.id) {
          index = i;
        }
        return task.id !== action.payload.id;
      });
      remainingTask.splice(index, 0, action.payload);
      state.tasks = [...remainingTask];
      const user = JSON.parse(localStorage.getItem("userData"));
      user.totalCompleted = state.tasks.filter((d) => d.isCompleted).length;
      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
    updateTask: (state, action) => {
      console.log("Updated");
      let index = 0;
      const remainingTask = state.tasks.filter((task, i) => {
        if (task?._id2 && task._id2 === action.payload._id2) {
          index = i;
        }
        return task?._id2 !== action.payload._id2;
      });
      const payloadtask = action.payload;
      delete payloadtask._id2;
      remainingTask.splice(index, 0, payloadtask);
      state.tasks = [...remainingTask];
      const taskOrder = JSON.parse(localStorage.getItem("taskOrder"));
      console.log(taskOrder);
      updateTaskOrder(remainingTask[0].userId, {
        taskOrder: [...taskOrder],
      }).catch((err) => console.log(err));
      const user = JSON.parse(localStorage.getItem("userData"));
      user.totalCompleted = state.tasks.filter((d) => d.isCompleted).length;
      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
  },
});

export const {
  addTask,
  loadData,
  removeTask,
  editTask,
  updateList,
  clearAllTasks,
  updateTask,
} = taskSlice.actions;

export const selectTask = (state) => state.task.tasks;

export default taskSlice.reducer;
